function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.DragDrop = t() : e.DragDrop = t();
}(self, function () {
  return function () {
    "use strict";

    var e = {
      523: function _(e, t, r) {
        r.d(t, {
          A: function A() {
            return c;
          }
        });
        var n = r(601),
            o = r.n(n),
            i = r(314),
            a = r.n(i)()(o());
        a.push([e.id, '.ce-block--drop-target .ce-block__content:before {\n  content: "";\n  position: absolute;\n  top: 50%;\n  left: -20px;\n  margin-top: -1px;\n  height: 8px;\n  width: 8px;\n  border: solid #a0a0a0;\n  border-width: 1px 1px 0 0;\n  -webkit-transform-origin: right;\n  transform-origin: right;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.ce-block--drop-target .ce-block__content:after {\n  background: none;\n}\n', ""]);
        var c = a;
      },
      314: function _(e) {
        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var r = "",
                  n = void 0 !== t[5];
              return t[4] && (r += "@supports (".concat(t[4], ") {")), t[2] && (r += "@media ".concat(t[2], " {")), n && (r += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), r += e(t), n && (r += "}"), t[2] && (r += "}"), t[4] && (r += "}"), r;
            }).join("");
          }, t.i = function (e, r, n, o, i) {
            "string" == typeof e && (e = [[null, e, void 0]]);
            var a = {};
            if (n) for (var c = 0; c < this.length; c++) {
              var s = this[c][0];
              null != s && (a[s] = !0);
            }

            for (var l = 0; l < e.length; l++) {
              var u = [].concat(e[l]);
              n && a[u[0]] || (void 0 !== i && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = i), r && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = r) : u[2] = r), o && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = o) : u[4] = "".concat(o)), t.push(u));
            }
          }, t;
        };
      },
      601: function _(e) {
        e.exports = function (e) {
          return e[1];
        };
      },
      72: function _(e) {
        var t = [];

        function r(e) {
          for (var r = -1, n = 0; n < t.length; n++) {
            if (t[n].identifier === e) {
              r = n;
              break;
            }
          }

          return r;
        }

        function n(e, n) {
          for (var i = {}, a = [], c = 0; c < e.length; c++) {
            var s = e[c],
                l = n.base ? s[0] + n.base : s[0],
                u = i[l] || 0,
                d = "".concat(l, " ").concat(u);
            i[l] = u + 1;
            var f = r(d),
                p = {
              css: s[1],
              media: s[2],
              sourceMap: s[3],
              supports: s[4],
              layer: s[5]
            };
            if (-1 !== f) t[f].references++, t[f].updater(p);else {
              var v = o(p, n);
              n.byIndex = c, t.splice(c, 0, {
                identifier: d,
                updater: v,
                references: 1
              });
            }
            a.push(d);
          }

          return a;
        }

        function o(e, t) {
          var r = t.domAPI(t);
          return r.update(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
              r.update(e = t);
            } else r.remove();
          };
        }

        e.exports = function (e, o) {
          var i = n(e = e || [], o = o || {});
          return function (e) {
            e = e || [];

            for (var a = 0; a < i.length; a++) {
              var c = r(i[a]);
              t[c].references--;
            }

            for (var s = n(e, o), l = 0; l < i.length; l++) {
              var u = r(i[l]);
              0 === t[u].references && (t[u].updater(), t.splice(u, 1));
            }

            i = s;
          };
        };
      },
      659: function _(e) {
        var t = {};

        e.exports = function (e, r) {
          var n = function (e) {
            if (void 0 === t[e]) {
              var r = document.querySelector(e);
              if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                r = r.contentDocument.head;
              } catch (e) {
                r = null;
              }
              t[e] = r;
            }

            return t[e];
          }(e);

          if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          n.appendChild(r);
        };
      },
      540: function _(e) {
        e.exports = function (e) {
          var t = document.createElement("style");
          return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
        };
      },
      56: function _(e, t, r) {
        e.exports = function (e) {
          var t = r.nc;
          t && e.setAttribute("nonce", t);
        };
      },
      825: function _(e) {
        e.exports = function (e) {
          if ("undefined" == typeof document) return {
            update: function update() {},
            remove: function remove() {}
          };
          var t = e.insertStyleElement(e);
          return {
            update: function update(r) {
              !function (e, t, r) {
                var n = "";
                r.supports && (n += "@supports (".concat(r.supports, ") {")), r.media && (n += "@media ".concat(r.media, " {"));
                var o = void 0 !== r.layer;
                o && (n += "@layer".concat(r.layer.length > 0 ? " ".concat(r.layer) : "", " {")), n += r.css, o && (n += "}"), r.media && (n += "}"), r.supports && (n += "}");
                var i = r.sourceMap;
                i && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), t.styleTagTransform(n, e, t.options);
              }(t, e, r);
            },
            remove: function remove() {
              !function (e) {
                if (null === e.parentNode) return !1;
                e.parentNode.removeChild(e);
              }(t);
            }
          };
        };
      },
      113: function _(e) {
        e.exports = function (e, t) {
          if (t.styleSheet) t.styleSheet.cssText = e;else {
            for (; t.firstChild;) {
              t.removeChild(t.firstChild);
            }

            t.appendChild(document.createTextNode(e));
          }
        };
      }
    },
        t = {};

    function r(n) {
      var o = t[n];
      if (void 0 !== o) return o.exports;
      var i = t[n] = {
        id: n,
        exports: {}
      };
      return e[n](i, i.exports, r), i.exports;
    }

    r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, {
        a: t
      }), t;
    }, r.d = function (e, t) {
      for (var n in t) {
        r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
          enumerable: !0,
          get: t[n]
        });
      }
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.nc = void 0;
    var n = {};
    return function () {
      r.d(n, {
        default: function _default() {
          return g;
        }
      });
      var e = r(72),
          t = r.n(e),
          o = r(825),
          i = r.n(o),
          a = r(659),
          c = r.n(a),
          s = r(56),
          l = r.n(s),
          u = r(540),
          d = r.n(u),
          f = r(113),
          p = r.n(f),
          v = r(523),
          y = {};

      function h(e) {
        return h = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
          return _typeof(e);
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
        }, h(e);
      }

      function b(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, m(n.key), n);
        }
      }

      function m(e) {
        var t = function (e, t) {
          if ("object" != h(e) || !e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, "string");
            if ("object" != h(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return String(e);
        }(e);

        return "symbol" == h(t) ? t : t + "";
      }

      y.styleTagTransform = p(), y.setAttributes = l(), y.insert = c().bind(null, "head"), y.domAPI = i(), y.insertStyleElement = d(), t()(v.A, y), v.A && v.A.locals && v.A.locals;

      var g = function () {
        return e = function e(t, r) {
          var n = t.configuration,
              o = t.blocks,
              i = t.toolbar,
              a = t.save;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.toolbar = i, this.borderStyle = r || "1px dashed #aaa", this.api = o, this.holder = "string" == typeof n.holder ? document.getElementById(n.holder) : n.holder, this.readOnly = n.readOnly, this.startBlock = null, this.endBlock = null, this.save = a, this.setDragListener(), this.setDropListener();
        }, r = [{
          key: "isReadOnlySupported",
          get: function get() {
            return !0;
          }
        }], (t = [{
          key: "setElementCursor",
          value: function value(e) {
            if (e) {
              var t = document.createRange(),
                  r = window.getSelection();
              t.setStart(e.childNodes[0], 0), t.collapse(!0), r.removeAllRanges(), r.addRange(t), e.focus();
            }
          }
        }, {
          key: "setDragListener",
          value: function value() {
            var e = this;

            if (!this.readOnly) {
              var t = this.holder.querySelector(".ce-toolbar__settings-btn");
              if (t) this.initializeDragListener(t);else {
                var r = new MutationObserver(function (t, r) {
                  var n = e.holder.querySelector(".ce-toolbar__settings-btn");
                  n && (e.initializeDragListener(n), r.disconnect());
                });
                r.observe(this.holder, {
                  childList: !0,
                  subtree: !0
                });
              }
            }
          }
        }, {
          key: "initializeDragListener",
          value: function value(e) {
            var t = this;
            e.setAttribute("draggable", "true"), e.addEventListener("dragstart", function () {
              t.startBlock = t.api.getCurrentBlockIndex();
            }), e.addEventListener("drag", function () {
              if (t.toolbar.close(), !t.isTheOnlyBlock()) {
                var e = t.holder.querySelectorAll(".ce-block"),
                    r = t.holder.querySelector(".ce-block--drop-target");
                t.setElementCursor(r), t.setBorderBlocks(e, r);
              }
            });
          }
        }, {
          key: "setBorderBlocks",
          value: function value(e, t) {
            var r = this;
            Object.values(e).forEach(function (n) {
              var o = n.querySelector(".ce-block__content");
              n !== t ? (o.style.removeProperty("border-top"), o.style.removeProperty("border-bottom")) : Object.keys(e).find(function (r) {
                return e[r] === t;
              }) > r.startBlock ? o.style.borderBottom = r.borderStyle : o.style.borderTop = r.borderStyle;
            });
          }
        }, {
          key: "setDropListener",
          value: function value() {
            var e = this;
            document.addEventListener("drop", function (t) {
              var r = t.target;

              if (e.holder.contains(r) && null !== e.startBlock) {
                var n = e.getDropTarget(r);

                if (n) {
                  var o = n.querySelector(".ce-block__content");
                  o.style.removeProperty("border-top"), o.style.removeProperty("border-bottom"), e.endBlock = e.getTargetPosition(n), e.moveBlocks();
                }
              }

              e.startBlock = null;
            });
          }
        }, {
          key: "getDropTarget",
          value: function value(e) {
            return e.classList.contains("ce-block") ? e : e.closest(".ce-block");
          }
        }, {
          key: "getTargetPosition",
          value: function value(e) {
            return Array.from(e.parentNode.children).indexOf(e);
          }
        }, {
          key: "isTheOnlyBlock",
          value: function value() {
            return 1 === this.api.getBlocksCount();
          }
        }, {
          key: "moveBlocks",
          value: function value() {
            this.isTheOnlyBlock() || this.api.move(this.endBlock, this.startBlock);
          }
        }]) && b(e.prototype, t), r && b(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
        var e, t, r;
      }();
    }(), n.default;
  }();
});